var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 .001C9.625-.089 4.067 3.667.572 7.513c-.76.844-.76 2.125 0 2.968C3.991 14.247 9.533 18.09 15 17.997c5.467.092 11.01-3.75 14.432-7.516.76-.843.76-2.124 0-2.968-1.466-1.612-3.295-3.208-5.32-4.512-1.438-.926-2.976-1.705-4.554-2.237-1.5-.506-3.036-.788-4.558-.763z",
    transform: "translate(9 15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9c0 2.761-2.24 5-5 4.999-2.762 0-5-2.24-5-5 0-2.762 2.239-5 5-5 1.326 0 2.599.526 3.536 1.464.938.938 1.465 2.21 1.464 3.537h0z",
    transform: "translate(9 15)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    stroke: "#FFF",
    strokeWidth: 1.5,
    transform: "rotate(45 7.422 49.763)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 40.324,
    x: -0.75,
    y: -0.138,
    rx: 0.75
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.f09edb0a599ee37aac0569332e79a409.svg";
export { ForwardRef as ReactComponent };